/// <reference types="datatables.net" />

import { Component, OnInit } from "@angular/core";
import { AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import { ApiIntegration } from "../../_services/api.integration";
import { Globals } from "../../_models/globals";
import { DataTableDirective } from "angular-datatables";
//import {LocalStorageService,SessionStorageService,LocalStorage,SessionStorage,} from "angular-web-storage";
import { environment } from "../../../environments/environment";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Router } from "@angular/router";
import { User } from "../../_models/user";
import { Subject } from "rxjs";
import { Register } from "../../_models/register";
import { Caller } from "../../_models/caller";

@Component({
  selector: "app-account-owner-selection",
  templateUrl: "./account-owner-selection.component.html",
  styleUrls: ["./account-owner-selection.component.css"],
})
export class AccountOwnerSelectionComponent implements OnInit {
  accountOwnerId: any;
  accountOwners: any;
  selectedWarehouse: any;
  warehouseDetailsErrorMessage: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private api: ApiIntegration,
    private g: Globals,
    public user: User,
    public register: Register,
    public caller: Caller
  ) {
    this.api.getAccountOwners("1", "ACTIVE").subscribe(
      (data: any) => {
        this.accountOwners = data.getAccountOwnersResponses;
      },
      (err) => {
        console.log(err);
      }
    );
    this.accountOwnerId = this.accountOwners;
    this.g.page = "Account Owner Selection";
  }

  ngOnInit() {}

  submitAccount() {
    this.accountOwnerId = this.accountOwners;
    this.router.navigate(["/admin/createInventory"]);
  }

  submitAccountOwner() {
    this.accountOwnerId = this.accountOwners;
    this.router.navigate(["/admin/createContacts"]);
  }

  submitStockAccount() {
    this.accountOwnerId = this.accountOwners;
    this.router.navigate(["/admin/stockEntryCreate"]);
  }
}
